// extracted by mini-css-extract-plugin
export var disabled = "_95-3";
export var growableInput = "_95-0";
export var tagContainer = "_95-2";
export var textInput = "_95-1";